import { useUpdatePresetMutationApi } from '@aibees/shared/api';
import { useAdvanceTableContext } from '@aibees/shared/features/advance-table/context';
import { useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StarCheckboxProps as Props } from './types';

export const StarCheckbox = memo(({ className, item }: Props) => {
  const { browseData } = useAdvanceTableContext();
  const { refetch } = browseData;

  const api = useUpdatePresetMutationApi(item.id);
  const notify = useNotify();
  const handleChange = () => {
    api.mutateAsync({ ...item, favorite: !item.favorite } as any).then(() => {
      notify.success(item.favorite ? 'Search unpinned!' : 'Search pinned!');
      refetch?.();
    });
  };

  return (
    <Styled.Wrapper
      className={classnames('StarCheckbox', className)}
      sx={SX.root}
      name="pin-filled-vertical"
      size={16}
      color={item.favorite ? 'primary.400' : 'primary.200'}
      onClick={handleChange}
    />
  );
});

StarCheckbox.displayName = 'StarCheckbox';
